// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"3dc788e4","112":"b40606be","128":"475a6bce","180":"075cfc7e","243":"62bbfcba","284":"30b9af34","312":"ca0b61f8","376":"86df18eb","423":"25bfa16f","448":"73a51ea9","488":"8aa3baa6","673":"db8b3cb3","819":"1004a1fe"}[chunkId] + ".chunk.js";
};